import { defineMessages } from 'react-intl-next';

export default defineMessages({
	unsupportedFile: {
		id: 'ai-mate.upload-files-to-conversation.unsupported-file',
		defaultMessage: 'Unsupported file type',
		description: 'Error message for unsupported file type',
	},
	unknownError: {
		id: 'ai-mate.upload-files-to-conversation.unknown-error',
		defaultMessage: 'There was an error uploading the file. Please try again.',
		description: 'Error message for unknown error',
	},
	fileRaiPolicyViolationError: {
		id: 'ai-mate.upload-files-to-conversation.file-rai-policy-violation',
		defaultMessage:
			'The file might not comply with our Acceptable Use Policy. Try a different file.',
		description: 'Error message for file RAI policy violation',
	},
	failToValidateFilesTitle: {
		id: 'ai-mate.upload-files-to-conversation.fail-to-validate-files-title',
		defaultMessage: 'Failed to validate files',
		description: 'Title for failed to validate files',
	},
	failToValidateFilesDescription: {
		id: 'ai-mate.upload-files-to-conversation.fail-to-validate-files-description',
		defaultMessage: 'Error occurred while validating files, please try again.',
		description: 'Description for failed to validate files',
	},
	invalidFilesTitle: {
		id: 'ai-mate.upload-files-to-conversation.refresh.invalid-files-title',
		defaultMessage: '{count, plural, one {File type} other {File types}} not supported',
		description: 'Title for invalid files',
	},
	invalidFilesDescription: {
		id: 'ai-mate.upload-files-to-conversation.refresh.invalid-files-description',
		defaultMessage:
			'{count, plural, one {The file "{fileNames}" is not supported. Reason: {reasons}} other {The following files: "{fileNames}" are not supported. Reason: {reasons}}}',
		description: 'Description for invalid files',
	},
	fileInvalidIconLabel: {
		id: 'ai-mate.upload-files-to-conversation.file-invalid-icon-label',
		defaultMessage: 'File is invalid',
		description: 'Label for file invalid icon',
	},
	validationErrorInvalidContentType: {
		id: 'ai-mate.upload-files-to-conversation.validation-error-invalid-content-type',
		defaultMessage: 'File type is not supported',
		description: 'Error message for invalid content type',
	},
	validationErrorFileTooLarge: {
		id: 'ai-mate.upload-files-to-conversation.validation-error-file-too-large',
		defaultMessage: 'File size is too large',
		description: 'Error message for file too large',
	},
	validationErrorFileNameMissing: {
		id: 'ai-mate.upload-files-to-conversation.validation-error-file-name-missing',
		defaultMessage: 'File name is missing',
		description: 'Error message for file name missing',
	},
	validationErrorUnknownError: {
		id: 'ai-mate.upload-files-to-conversation.validation-error-unknown-error',
		defaultMessage: 'Fail to validate file for unknown reason',
		description: 'Error message for unknown error',
	},
	validationErrorMissingErrorCode: {
		id: 'ai-mate.upload-files-to-conversation.validation-error-missing-error-code',
		defaultMessage: 'Validation result unknown',
		description: 'Error message for missing error code',
	},
	validationErrorNotFound: {
		id: 'ai-mate.upload-files-to-conversation.validation-error-not-found',
		defaultMessage: 'Validation result is not found',
		description: 'Error message for not found',
	},
});
